<!--年度各企业农机报废补贴额-->
<template>
  <div class="location-number">
    <seamless-scroll
      class="locaiton-scroll"
      :data='scrapSubsidyList'
      :class-option="classOption"
    >
      <div
        class="subsidy-box"
        v-for="(item,index) in scrapSubsidyList"
        :key="index"
      >
        <div class="item-left item-common"  v-if="item.left">
          <p class="item-title">{{turnNeed(item.left)}}</p>
          <div class="item-num">
            <span :data-content="numberFloatSeparatorCompute(item.left.subsidyAmount)">{{item.left.subsidyAmount || 0 | toThousandFloatFilter}}</span>万元
          </div>
        </div>
        <div class="item-right item-common" v-if="item.right">
          <div>
            <p class="item-title">{{turnNeed(item.right)}}</p>
            <div class="item-num">
              <span :data-content="numberFloatSeparatorCompute(item.right.subsidyAmount)">{{item.right.subsidyAmount || 0 | toThousandFloatFilter}}</span>万元
            </div>
          </div>
        </div>
        <div v-else class="item-right item-right-empty"></div>
      </div>
    </seamless-scroll>

  </div>
</template>

<script>
export default {
  name: 'machinerySubsidy',
  props: {
    scrapSubsidyList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      classOption: {
        step: 0.5,
        limitMoveNum: 3
      },
 
    }
  },
  computed: {
    numberSeparatorCompute() {
      return function(number){
        let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
        if (!number) {
          return 0;
        }else {
          return number.toFixed().replace(regex, ',');
        }
      }
    },
    numberFloatSeparatorCompute() {
      return function(number){
        let num = number;
        if(!number) {
          num = 0;
        }
        return num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
    },
    turnNeed() {
      return function(obj){
        if(obj && obj.factoryNameHuis) {
          if(obj.factoryNameHuis.length > 14) {
            obj.factoryNameHuis = obj.factoryNameHuis.slice(0, 13) + '...' 
          }
          return obj.factoryNameHuis
          
        }else {
          return '--';
        }
      }
    }

  },
  methods: {
 
  },
}
</script>
<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.location-number {
  height: 100%;
  padding-left: vh(9);
  margin-top: vh(10);
  font-family: Microsoft YaHei;
  display: flex;
  flex-direction: column;
  .locaiton-scroll {
    height: 100%;
    overflow: hidden;
  }
  .subsidy-box {
    display: flex;
    flex: 1;
    align-items: center;
    background-size: 100%;
    font-family: 'Microsoft YaHei';
    font-size: fontSize(14);
    color: #FFFFFF;
    padding-top: vh(14);
    margin-bottom: vh(8);
    .item-common {
      width: vw(238);
      height: vh(52);
      background: url("../../../../assets/images/governmentAffairs/scrapSubsidy/bg_list_bfbte.png") no-repeat;
      background-size: 100%;
      position: relative;
      .item-title {
        position: absolute;
        top: vh(-14);
        left: vw(16);
      }
      .item-num {
        position: absolute;
        bottom: vh(12);
        left: vw(16);
        font-size: fontSize(12);
        color: #50A66E;
        font-style: italic;
        span {
          position: relative;
          padding-right: vh(4);
          font-family: 'Rajdhani';
          font-weight: 600;
          font-size: fontSize(24);
          background: linear-gradient(0deg, #8FF7B4 0%, #FFFFFF 60%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        span::before {
          content: attr(data-content);
          position: absolute;
          top: 0;
          left: 0;
          text-shadow: 0px 3px 7px rgba(0,0,0,0.35);
        }
      }
    }
    .item-left {

    }
    .item-right {
      margin-left: vw(12);
    }
    .item-right-empty {
      width: vw(238);
      height: vh(52);
    }
  }
}
</style>
